// START_MODULE components_atoms_button_button_tsx
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import styled, { css } from 'styled-components';
import React, { ButtonHTMLAttributes } from 'react';

import { IChildren } from 'utils/interfaces/IChildren';

const Button: React.FC<IChildren & ButtonHTMLAttributes<any>> = ({ children, ...rest }) => (
  <ButtonPushable type="button" {...rest}>
    <span>
      <span>{children}</span>
    </span>
  </ButtonPushable>
);

export default Button;

const ButtonPushable = styled.button`
  ${({ theme }) => css`
    cursor: pointer;
    background: white;
    position: relative;

    font-weight: 700;
    padding: 8px 14px;
    border: 2px solid ${theme.accentColor};
    color: #fff;

    span {
      position: relative;
      overflow: hidden;
      display:flex;
      align-items: center;
      gap: 4px;
    }

    &:hover > span > span {
      animation: MoveUpInitial 0.2s forwards, MoveUpEnd 0.2s forwards 0.2s;
    }

    @keyframes MoveUpInitial {
      to {
        transform: translate3d(0, -105%, 0);
      }
    }

    @keyframes MoveUpEnd {
      from {
        transform: translate3d(0, 100%, 0);
        color: white;
      }
      to {
        transform: translate3d(0, 0, 0);
        color: black;
      }
    }

    &::before {
      content: '';

      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      background: ${theme.accentColor};
      transition: transform 0.3s cubic-bezier(0.7, 0, 0.2, 1);
      transform-origin: 100% 50%;
    }

    &:hover::before {
      transform: scale3d(0, 1, 1);
      transform-origin: 0 50%;
    }
  `};
`;

// END_MODULE components_atoms_button_button_tsx
